import { create } from 'zustand'
import { api } from '../api/client'

interface AuthState {
  token: string | null  // Phase 0.11: 仅内存持有, 给 ExtensionHub 注入扩展用
  role: string | null
  displayName: string | null
  loading: boolean
  login: (username: string, password: string) => Promise<void>
  logout: () => Promise<void>
  isAuthenticated: () => boolean
}

export const useAuth = create<AuthState>((set, get) => ({
  token: null,
  role: localStorage.getItem('role'),
  displayName: localStorage.getItem('displayName'),
  loading: false,

  login: async (username, password) => {
    set({ loading: true })
    try {
      const data = await api.post<{
        access_token: string
        role: string
        display_name: string
      }>('/auth/login', { username, password })
      // 不写 token 到 localStorage; 服务端已 Set-Cookie httpOnly
      localStorage.setItem('role', data.role)
      localStorage.setItem('displayName', data.display_name)
      set({ token: data.access_token, role: data.role, displayName: data.display_name })
    } finally {
      set({ loading: false })
    }
  },

  logout: async () => {
    try {
      await api.post('/auth/logout')
    } catch {
      // 离线/401 也继续清本地
    }
    localStorage.removeItem('role')
    localStorage.removeItem('displayName')
    // 兼容旧会话: 清历史 token key (如果还存着)
    localStorage.removeItem('token')
    localStorage.removeItem('displayName')
    set({ token: null, role: null, displayName: null })
  },

  // cookie 不可读,只能靠 role UX 缓存; 首次 API 401 会由 client.ts 清 + 跳转
  isAuthenticated: () => !!get().role,
}))
